import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import SlideLinkWithPreview from 'components/atoms/SlideLinkWithPreview';
import { MultiplexPanelView } from 'interfaces/multiplexPanels';
import { includes, join, map } from 'lodash';
import React, { useState } from 'react';
import { PanelSlideDetails } from './PanelSlideDetails';

export const PanelSlideSummary = ({
  panel,
  labId,
  selectedSlideIds,
  onSelectionChange,
  disabled = false,
}: {
  panel: MultiplexPanelView;
  labId?: string;
  selectedSlideIds?: string[];
  onSelectionChange?: (slideId: string, selected: boolean) => void;
  disabled?: boolean;
}) => {
  const [page, setPage] = useState(0);
  const currentPage = Math.min(page, Math.max(Math.ceil(panel.slides.length / 10) - 1, 0));
  return (
    <PanelSlideDetails
      panelId={panel.panelId}
      slideCount={panel.slides.length}
      selectedCount={selectedSlideIds?.length}
    >
      <TableContainer>
        <Table size="small" aria-label={`${panel.panelId} slide summary`}>
          <TableHead>
            <TableRow>
              {onSelectionChange && <TableCell>Select</TableCell>}
              <TableCell>Slide ID</TableCell>
              <TableCell>Case label</TableCell>
              <TableCell>Source file name</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {map(panel.slides.slice(currentPage * 10, (currentPage + 1) * 10), (slide) => (
              <TableRow key={slide.slideId}>
                {onSelectionChange && (
                  <TableCell>
                    <Checkbox
                      disabled={disabled}
                      checked={includes(selectedSlideIds, slide.slideId)}
                      inputProps={{ 'aria-label': `Select slide ${slide.slideId}` }}
                      onChange={(_event, checked) => onSelectionChange(slide.slideId, checked)}
                    />
                  </TableCell>
                )}
                <TableCell>
                  <SlideLinkWithPreview slideid={slide.slideId} labid={labId}>
                    {slide.slideId}
                  </SlideLinkWithPreview>
                </TableCell>
                <TableCell>{join(slide.caseLabels || [], ', ') || 'Unassigned'}</TableCell>
                <TableCell>{slide.originalFileName || 'Unavailable'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={panel.slides.length}
        page={currentPage}
        rowsPerPage={10}
        rowsPerPageOptions={[10]}
        onPageChange={(_event, nextPage) => setPage(nextPage)}
      />
    </PanelSlideDetails>
  );
};
